import React from 'react'

import { useVehiclesCheckedInCountQuery, CardType } from '@edge/spark/io-dashboards'
import { SingleNumberWidget } from '../../BaseComponents/SingleNumberWidget'
import { BasicWidgetProps } from '../../types'

const VehiclesCheckedInCount = ({
    config: { text = 'Vehicles', text2 = 'Checked In', secondaryText = 'Today' },
    widgetId,
    handleConfig,
    readonly,
}: BasicWidgetProps): React.ReactElement => {
    const { data, loading } = useVehiclesCheckedInCountQuery({
        variables: { searchString: 'checkindate:0' },
    })

    const count = data?.auction?.search?.vehicleCount || 0

    return (
        <SingleNumberWidget
            cardType={CardType.VEHICLE}
            action={{
                text: 'View Vehicles',
                link: `/vehiclescheckedin`,
            }}
            number={count}
            text={text}
            text2={text2}
            secondaryText={secondaryText}
            loading={loading}
            widgetId={widgetId}
            handleConfig={handleConfig}
            readonly={readonly}
        />
    )
}

export default VehiclesCheckedInCount
